<template>
    <div class="app-container">
        <el-card class="search-form-card">

            <el-form :inline="true" :model="form" class="search-form">

                <el-form-item label="关键字搜索">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" style='width: 200px;'></el-input>
                    <el-button type="primary" @click="request">搜索</el-button>
                </el-form-item>

            </el-form>

        </el-card>
        <el-card>
            <div slot="header" class='project_head'>
                <div :class='isShowTree? "tree hoverActive" : "tree" '
                     @mouseover='isShowTree = true'
                     @mouseout='isShowTree = false'>
                    <span>{{ title }}</span>
                    <div class="voiture-container" v-show="isShowTree">
                        <el-tree :props="props" :load="loadNode" lazy highlight-current accordion :expand-on-click-node='false' v-loading='treeLoading'>
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span @click='nodeClick(data)'>{{ node.data.title }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div>

            </div>

            <el-table :data="tableData" stripe v-loading='loading' @selection-change='handleSelectionChange'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.pageSize===item">
                            {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column type="selection" width="55"></el-table-column>

                <el-table-column label="配置项编号" prop="serialNumber"></el-table-column>

                <el-table-column label="配置项名称" prop="title"></el-table-column>

                <el-table-column label="配置项分类" prop="category"></el-table-column>

                <el-table-column label="配置项状态">
                    <template slot-scope='scope'>
                        {{ scope.row.status | tableVal(cmdbStatus) }}
                    </template>
                </el-table-column>

                <el-table-column label="创建时间" prop="createTime"></el-table-column>
            </el-table>

            <!-- 分页器 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.pageIndex" :page-sizes="[10,20, 30, 40]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
            >
            </el-pagination>
        </el-card>
        <div style="margin:70px 0 10px 0;display: flex;">
            <el-button type="primary" size="small" @click="submit">确定</el-button>
            <el-button type="default" size="small" @click="onCancel">取消</el-button>
        </div>

    </div>
</template>

<script>
import services from "./addConfiguration.services";
export default {
    props:{
        callback:Function
    },
    data() {
        return {
            form: {
                pageSize: 10,
                pageIndex: 1,
                keyword: ""
            },
            total: 0,
            tableData: [],
            pageSizes: [10, 20, 30, 40],
            multipleSelection:[],
            loading: true,
            treeLoading: true,
            isShowTree: false,
            title: "配置项分类",
            props: {
                label: "name",
                children: "zones",
                isLeaf: "hasChildren"
            }
        };
    },
    computed: {
        dictionary() {
            return this.$store.state.dictionary;
        },
        cmdbStatus() {
            return this.dictionary.cmdb_status;
        }
    },
    mounted() {
        this.request();
    },
    methods: {
        nodeClick(data) {
            // 点击查找分类列表
            this.form.category = data.id;
            this.request({ category: data.id });
        },
        // 请求数据查找子项
        loadNode(node, resolve) {
            if (node.level === 0) {
                services.typeList({ type: 11 }).then(res => {
                    let newArr = res.map(item => ({
                        id: item.id,
                        title: item.title,
                        leaf: !item.hasChildren
                    }))
                    resolve(newArr)
                    this.treeLoading = false
                })
            } else {
                services.childrenList({ parentId: node.data.id }).then(res => {
                    let newArr = res.map(item => ({
                        id: item.id,
                        title: item.title,
                        leaf: !item.hasChildren
                    }))
                    resolve(newArr);
                    this.treeLoading = false
                })
            }
        },

        request(params) {
            // 获取列表数据
            if (params) {
                params = {
                    ...params,
                    ...this.form
                    };
                }
                this.tableData = [];
                this.loading = true;
                services.cmdbLlist(params || this.form)
                        .then(res => {
                        this.tableData = res.list;
                        this.total = +res.total;
                        })
                        .catch(err => this.$message.error(err.message))
                        .finally(() => (this.loading = false));
        },
        deleteRow(index, rows, serialNumber) {
            // 删除列表某一项
            this.$confirm("此操作将永久删除该合同, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                services
                    .cmdbdDelete({ serialNumber: serialNumber })
                    .then(res => {
                    this.$message.success("删除成功!");
                    rows.splice(index, 1);
                    })
                    .catch(err => this.$message.error(err.message));
            })
            .catch(() => this.$message.info("已取消删除"))
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        submit(){
            if(this.multipleSelection.length == 0){
                this.$message.error("请至少选择一个")
            }else{
                this.callback(this.multipleSelection);
                this.$modal.close();
            }
        },
        onCancel(){
            this.close();
        },
        close(refresh) {
            this.$modal.close();
            refresh && refresh === true ? this.callback() : '';
        },
        handleSizeChange(val) {
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if (this.form.pageIndex > pages) {
                this.form.pageIndex = 1;
            }
            this.request();
        },
        handleCurrentChange(val) {
            this.form.pageIndex = val;
            this.request();
        },

    }
};
</script>

<style lang="scss" scoped>
.project_head {
  position: relative;
  .tree {
    width: 150px;
    position: absolute;
    top: -10px;
    right: 0;
    z-index: 1000;
    .voiture-container {
      height: 200px;
      overflow: hidden;
      overflow-y: auto;
      backface-visibility: hidden;
    }
  }
  > div.hoverActive {
    background: #fff;
  }
}
</style>

